import { useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";

export default function V2Home() {
  const navigate = useNavigate();
  const { customerId } = useParams();
  const { user } = useContext(AuthContext);

  useEffect(() => {
    if (!user) return;
    const base = `/customers/${customerId}/v2`;
    if (user.hasPermission("interactions:Read")) {
      navigate(`${base}/dashboard`, { replace: true });
    } else {
      navigate(`${base}/search`, { replace: true });
    }
  }, [user, customerId, navigate]);

  return null;
}
